<template>
  <div>
    <div class="top-tab">
        <ul class="nav nav-tabs" role="tablist">
          <li role="presentation" class="active"><a href="#CampaignInsights" aria-controls="pickl" role="tab" data-toggle="tab">Campaign Insights</a></li>
          <li role="presentation"><a href="#ConsumerInsights" aria-controls="pickl" role="tab" data-toggle="tab">Consumer Insights</a></li>
          <li role="presentation"><a href="#BuyMeInsights" aria-controls="pickl" role="tab" data-toggle="tab">Buy Me Insights</a></li>
          <li role="presentation"><a href="#MediaInsights" aria-controls="pickl" role="tab" data-toggle="tab">Media Insights</a></li>
        </ul>
    </div>

    <div class="tab-content">
      <div class="filter pull-right" :class="showFilterPop?'open': ''">
          <a class="nav-link dropdown-toggle" href="#" @click="showFilterPop = true" role="button"
           style="text-transform: none;">Filter</a>
          <a href="#" @click="printDownload">Export</a>

          <div class="filter-box dropdown-menu" v-show="showFilterPop" style="text-transform: none;color: #782B55;">
          <h5 style="color: #000; font-size: 20px;border-bottom: 1px solid;padding-bottom: 18px;">Filters
            <a @click="showFilterPop = false" style="float: right;margin-top: -8px;" href="javascript:;">X</a>
          </h5>
            <button @click="togglePersonalFilters" v-html="showPersonalDetailsFilter? '- Date Range':'+ Date Range'"></button>
            <div class="form-card" v-show="showPersonalDetailsFilter">
              <label>From Date</label>
              <input v-model="filters.startDate" type="date" name="startDate" placeholder="From Date">
              <label>To Date</label>
              <input v-model="filters.endDate" type="date" name="endDate" placeholder="To Date">
            </div>
            <button @click="toggleCampaignFilters" v-html="showCampaignFilter? '- Campaign Name':'+ Campaign Name'"></button>
            <div class="form-card" v-show="showCampaignFilter">
            <select v-model="filters.campaignId" name="campaignId" class="form-control">
              <option value="">Select</option>
              <option  v-for="campaign in campaignList" :key="campaign.id" :value="campaign.id">{{ campaign.name }}</option>
            </select>
            </div>
            <button @click="toggleRetailerFilters" v-html="showRetailerFilter? '- Retailer Name':'+ Retailer Name'"></button>
            <div class="form-card" v-show="showRetailerFilter">
              <select v-model="filters.storeId" name="storeId" class="form-control">
                <option value="">Select</option>
                <option  v-for="retailer in retailerList" :key="retailer.id" :value="retailer.id">{{ retailer.name }}</option>
              </select>
            </div>
            <button @click="toggleProductFilters" v-html="showProductFilter? '- Product Name':'+ Product Name'"></button>
            <div class="form-card" v-show="showProductFilter">
            <select v-model="filters.productId" name="productId" class="form-control">
              <option value="">Select</option>
              <option  v-for="product in productList" :key="product.id" :value="product.id">{{ product.name }}</option>
            </select>
            </div>
            <h5 style="color: #000;margin-top: 30px;padding-top: 25px; font-size: 17px;border-top: 1px solid;padding-bottom: 10px;">For Consumer Insights</h5>
            <button @click="toggleGenderFilters" v-html="showGenderFilter? '- Gender':'+ Gender'"></button>
            <div class="form-card" v-show="showGenderFilter">
            <select v-model="filters.gender" name="gender" class="form-control">
              <option value="">Select</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
              <option value="other">Other</option>
            </select>
            </div>
            <!-- <button>Age</button> -->
            <button @click="toggleEthnicFilters" v-html="showEthnicFilter? '- Ethnic':'+ Ethnic'"></button>
            <div class="form-card" v-show="showEthnicFilter">
            <select v-model="filters.ethnicBackground" name="ethnicBackground" class="form-control">
              <option value="">Select</option>
              <option  v-for="ethnic in ethnicBackground" :key="ethnic.ethnic_background" :value="ethnic.ethnic_background">{{ ethnic.ethnic_background }}</option>
            </select>
            </div>
            <button @click="togglePetsFilters" v-html="showPetsFilter? '- Pets':'+ Pets'"></button>
            <div class="form-card" v-show="showPetsFilter">
            <select v-model="filters.pets" name="pets" class="form-control">
              <option value="">Select</option>
              <option  v-for="pets in petsList" :key="pets.pets" :value="pets.pets">{{ pets.pets }}</option>
            </select>
            </div>
            <button @click="toggleCosmeticFilters" v-html="showCosmeticFilter? '- Cosmetics':'+ Cosmetics'"></button>
            <div class="form-card" v-show="showCosmeticFilter">
            <select v-model="filters.cosmetics" name="cosmetics" class="form-control">
              <option value="">Select</option>
              <option  v-for="cosmetics in cosmeticsList" :key="cosmetics.cosmetics" :value="cosmetics.cosmetics">{{ cosmetics.cosmetics }}</option>
            </select>
            </div>

            <button @click="toggleChildrenFilters" v-html="showChildrenFilter? '- Children':'+ Children'"></button>
            <div class="form-card" v-show="showChildrenFilter">
            <select v-model="filters.children" name="children" class="form-control">
              <option value="">Select</option>
              <option  v-for="children in childrenList" :key="children.children" :value="children.children">{{ children.children }}</option>
            </select>
            </div>

            <a href="#" class="apply-btn" @click="getSucessMetrics">Apply</a>
            <a href="/brand/data-analysis" class="apply-btn" style="margin-left: 20px !important;">Reset</a>
          </div>

        </div>
        <div style="width: 100%;float: left;"></div>
      <div role="tabpanel" class="tab-pane fade in active" id="CampaignInsights">

        <h3 style="clear: both;">Campaign Summary</h3>
        <!--<data-success-metrics :brandId="brandId" :leadConversionRate="leadConversionRate" :SalesConversionRate="SalesConversionRate" :retentionRate="retentionRate" :upsellRatio="upsellRatio" :leadConversionRateNumber="leadConversionRateNumber" :SalesConversionRateNumber="SalesConversionRateNumber" :retentionRateNumber="retentionRateNumber" :upsellRatioNumber="upsellRatioNumber" :activitiesWithIssuesNumber="activitiesWithIssuesNumber" :activitiesWithIssuesPercentage="activitiesWithIssuesPercentage"></data-success-metrics>-->
        <campaign-summary :brandId="brandId" :activitiesCompletedNumber="activitiesCompletedNumber" :activitiesCompletedPercentage="activitiesCompletedPercentage" :upsellRatio="upsellRatio" :activitiesWithIssuesNumber="activitiesWithIssuesNumber" :activitiesWithIssuesPercentage="activitiesWithIssuesPercentage" :repeatLocations="repeatLocations" :byMeCreditConsumed="byMeCreditConsumed" :AverageLeadResponseTime="AverageLeadResponseTime" :FastestLeadResponseTime="FastestLeadResponseTime" :tripsFrequency="tripsFrequency" :basketSize="basketSize" :SalesConversionRateNumber="SalesConversionRateNumber" :SalesConversionRate="SalesConversionRate" :retentionRateNumber="retentionRateNumber" :upsellRatioNumber="upsellRatioNumber"></campaign-summary>
        <h3 style="clear: both;">Engagement Time</h3>
        <data-engagement-time :brandId="brandId" :totalTimeMinutes="totalTimeMinutes" :surveyTotalTimeMinutes="surveyTotalTimeMinutes" :surveyAvgEngagementMinutes="surveyAvgEngagementMinutes" :avgEngagementMinutes="avgEngagementMinutes" :fastestActivityMinutes="fastestActivityMinutes" :slowestActivityminutes="slowestActivityminutes" :productTotalTimeMinutes="productTotalTimeMinutes" :productAvgEngagementMinutes="productAvgEngagementMinutes"></data-engagement-time>
        <!--<h3 style="clear: both;">Product Engagement Time</h3>
        <data-product-engagement-time :brandId="brandId" :productTotalTimeMinutes="productTotalTimeMinutes" :productAvgEngagementMinutes="productAvgEngagementMinutes" :productFastestActivityMinutes="productFastestActivityMinutes" :productSlowestActivityminutes="productSlowestActivityminutes"></data-product-engagement-time>-->
        <h3 style="clear: both;">Touchpoints</h3>
        <data-touchpoints :brandId="brandId" :touchPointTotalGeo="touchPointTotalGeo" :touchPointAvgGeo="touchPointAvgGeo"></data-touchpoints>
        <h3 style="clear: both;">Photos Engagement Time</h3>
        <data-photos-engagement-time :brandId="brandId" :photoTotalTimeMinutes="photoTotalTimeMinutes" :photoAvgEngagementMinutes="photoAvgEngagementMinutes" :photoFastestActivityMinutes="photoFastestActivityMinutes" :photoSlowestActivityminutes="photoSlowestActivityminutes"></data-photos-engagement-time>
        <h3 style="clear: both;">Survey Engagement Time</h3>
        <data-survey-engagement-time :brandId="brandId" :surveyTotalTimeMinutes="surveyTotalTimeMinutes" :surveyAvgEngagementMinutes="surveyAvgEngagementMinutes" :surveyFastestActivityMinutes="surveyFastestActivityMinutes" :surveySlowestActivityminutes="surveySlowestActivityminutes"></data-survey-engagement-time>

      <h3 style="clear: both;">Selfies Engagement Time</h3>
        <data-selfies-engagement-time :brandId="brandId" :SelfieTotalTimeMinutes="SelfieTotalTimeMinutes" :SelfieAvgEngagementMinutes="SelfieAvgEngagementMinutes" :SelfieFastestActivityMinutes="SelfieFastestActivityMinutes" :SelfieSlowestActivityminutes="SelfieSlowestActivityminutes"></data-selfies-engagement-time>
        <h3>Social Selfies</h3>
        <user-social-selfies-data :brandId="brandId"></user-social-selfies-data>
        <!--<h3>Campaign Summary</h3>
        <campaign-summary :brandId="brandId" :activitiesCompletedNumber="activitiesCompletedNumber" :activitiesCompletedPercentage="activitiesCompletedPercentage" :activitiesWithIssuesNumber="activitiesWithIssuesNumber" :activitiesWithIssuesPercentage="activitiesWithIssuesPercentage" :repeatLocations="repeatLocations" :byMeCreditConsumed="byMeCreditConsumed" :AverageLeadResponseTime="AverageLeadResponseTime" :FastestLeadResponseTime="FastestLeadResponseTime" :tripsFrequency="tripsFrequency" :basketSize="basketSize"></campaign-summary> -->
        <div class="row">
          <div class="col-md-7">
            <div class="coast-box">
            <h3>Coast to Coast activities</h3>
            <coast-to-coast-activities :brandId="brandId" :coastToCoastData="coastToCoastData"></coast-to-coast-activities>
            </div>
          </div>
          <div class="col-md-5">
            <div class="coast-box">
              <h3>Activities with Issues summary</h3>
              <activities-with-issues-summary :brandId="brandId" :activitiesWithIssuesSummaryData="activitiesWithIssuesSummaryData"></activities-with-issues-summary>
            </div>
          </div>
        </div>
        <div class="row" style="margin-top: 30px;">
          <div class="col-md-7">
            <div class="coast-box">
            <h3>PICKL Purchases</h3>
            <pickl-purchases :brandId="brandId" :successfulpicklData="successfulpicklData" :picklPurchasesData="picklPurchasesData"></pickl-purchases>
            </div>
          </div>
          <div class="col-md-5">
            <div class="coast-box">
              <h3>Incremental Trips</h3>
              <incremental-trips :brandId="brandId" :incrementalTripsData="incrementalTripsData"></incremental-trips>
            </div>
          </div>
        </div>

      </div>
      <div role="tabpanel" class="tab-pane fade in" id="ConsumerInsights">
        <select v-model="selectedQuestionId" name="questionId" class="form-control" style="max-width: 58.333%;" @change="setSelectedQuestion">
          <option  v-for="question in questionsList" :key="question.id" :value="question.id">{{ question.question }}</option>
        </select>
        <div class="row" style="margin-top: 30px;">
          <div class="col-md-7">
            <div class="coast-box">
            <h3>{{selectedQuesetion.question}}</h3>
            <insight-question :brandId="brandId" :insightData="insightData"></insight-question>
            </div>
          </div>
          <div class="col-md-5">
            <div class="coast-box">
              <h3>{{selectedQuesetion.question}}</h3>
              <insight-overall :brandId="brandId" :insightOverallData="insightOverallData" ></insight-overall>
            </div>
          </div>
        </div>
      </div>
      <div role="tabpanel" class="tab-pane fade in" id="BuyMeInsights" style="border: 2px solid #12db6d;width: 100%; padding: 25px;margin-top: 30px;float: left;">
          <h3 style="margin-top: 10px;">Product Purchase Summary</h3>
          <product-purchase-summary :brandId="brandId" :ProductPurchaseSummaryData="ProductPurchaseSummaryData"></product-purchase-summary>
      </div>
      <div role="tabpanel" class="tab-pane fade in" id="MediaInsights">
        <div class="media_insights">
          <img src="/img/lock_media.png">
          <h5 style="font-size: 22px;line-height: 32px;">Contact customer service to<br> launch a Go-Anywhere campaign</h5>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import Card from '@/components/common/Card.vue'
import MediaPages from '@/components/Brand/Reports/MediaPages'
import ProductInsights from '@/components/Brand/Reports/ProductInsights'
import RetailerInsights from '@/components/Brand/Reports/RetailerInsights'
import ShoppingInsights from '@/components/Brand/Reports/ShoppingInsights'
import StoreInsights from '@/components/Brand/Reports/StoreInsights'
import StateInsights from '@/components/Brand/Reports/StateInsights'
import PicklsInsights from '@/components/Brand/Reports/PicklsInsights'
import SurveyInsights from '@/components/Brand/Reports/SurveyInsights.vue'
import PicklTypeInsights from '@/components/Brand/Reports/PicklTypeInsights'
import AverageCompletionTimes from '@/components/Brand/Reports/AverageCompletionTimes.vue'
import IssuesInsights from '@/components/Brand/Reports/IssuesInsights.vue'
import UserSocialSelfiesData from '@/components/Brand/Reports/UserSocialSelfiesData.vue'
import DataSuccessMetrics from '@/components/Brand/Reports/DataSuccessMetrics.vue'
import DataEngagementTime from '@/components/Brand/Reports/DataEngagementTime.vue'
import DataProductEngagementTime from '@/components/Brand/Reports/DataProductEngagementTime.vue'
import DataPhotosEngagementTime from '@/components/Brand/Reports/DataPhotosEngagementTime.vue'
import DataSurveyEngagementTime from '@/components/Brand/Reports/DataSurveyEngagementTime.vue'
import DataSelfiesEngagementTime from '@/components/Brand/Reports/DataSelfiesEngagementTime.vue'
import DataTouchpoints from '@/components/Brand/Reports/DataTouchpoints.vue'
import CampaignSummary from '@/components/Brand/Reports/CampaignSummary.vue'
import CoastToCoastActivities from '@/components/Brand/Reports/CoastToCoastActivities.vue'
import ActivitiesWithIssuesSummary from '@/components/Brand/Reports/ActivitiesWithIssuesSummary.vue'
import IncrementalTrips from '@/components/Brand/Reports/IncrementalTrips.vue'
import PicklPurchases from '@/components/Brand/Reports/PicklPurchases.vue'
import InsightQuestion from '@/components/Brand/Reports/InsightQuestion.vue'
import InsightOverall from '@/components/Brand/Reports/InsightOverall.vue'
import ProductPurchaseSummary from '@/components/Brand/Reports/ProductPurchaseSummary.vue'

export default {
  name: 'Dashboard',
  components: {
    Card,
    apexcharts: VueApexCharts,
    MediaPages,
    ProductInsights,
    RetailerInsights,
    StoreInsights,
    ShoppingInsights,
    StateInsights,
    PicklsInsights,
    SurveyInsights,
    PicklTypeInsights,
    AverageCompletionTimes,
    IssuesInsights,
    UserSocialSelfiesData,
    DataSuccessMetrics,
    DataTouchpoints,
    DataEngagementTime,
    DataProductEngagementTime,
    DataPhotosEngagementTime,
    DataSurveyEngagementTime,
    DataSelfiesEngagementTime,
    CampaignSummary,
    CoastToCoastActivities,
    ActivitiesWithIssuesSummary,
    IncrementalTrips,
    PicklPurchases,
    InsightQuestion,
    InsightOverall,
    ProductPurchaseSummary
  },
  data: function () {
    return {
      filters: {
        productId: '',
        startDate: '',
        endDate: '',
        campaignId: '',
        storeId: '',
        questionId: '',
        gender: '',
        ethnicBackground: '',
        pets: '',
        cosmetics: '',
        children: ''
      },
      showFilterPop: false,
      showPersonalDetailsFilter: false,
      showCampaignFilter: false,
      showRetailerFilter: false,
      showProductFilter: false,
      showGenderFilter: false,
      showEthnicFilter: false,
      showPetsFilter: false,
      showCosmeticFilter: false,
      showChildrenFilter: false,
      selectedQuestionId: '',
      leadConversionRate: '',
      retentionRate: '',
      upsellRatio: '',
      SalesConversionRateNumber: '',
      retentionRateNumber: '',
      activitiesCompletedNumber: '',
      byMeCreditConsumed: '',
      FastestLeadResponseTime: '',
      tripsFrequency: '',
      basketSize: '',
      totalTimeMinutes: '',
      productTotalTimeMinutes: '',
      SelfieTotalTimeMinutes: '',
      photoTotalTimeMinutes: '',
      surveyTotalTimeMinutes: '',
      avgEngagementMinutes: '',
      productAvgEngagementMinutes: '',
      photoAvgEngagementMinutes: '',
      surveyAvgEngagementMinutes: '',
      SelfieAvgEngagementMinutes: '',
      fastestActivityMinutes: '',
      SelfieActivityMinutes: '',
      productFastestActivityMinutes: '',
      photoFastestActivityMinutes: '',
      surveyFastestActivityMinutes: '',
      slowestActivityminutes: '',
      SelfieActivityminutes: '',
      productSlowestActivityminutes: '',
      photoSlowestActivityminutes: '',
      surveySlowestActivityminutes: '',
      activitiesWithIssuesPercentage: '',
      repeatLocations: '',
      upsellRatioNumber: '',
      leadConversionRateNumber: '',
      SalesConversionRate: '',
      picklPurchasesData: '',
      activitiesWithIssuesNumber: '',
      AverageLeadResponseTime: '',
      touchPointTotalGeo: '',
      activitiesCompletedPercentage: '',
      selectedQuesetion: {},
      insightData: {},
      questionsList: [],
      campaignList: [],
      retailerList: [],
      productList: [],
      ethnicBackground: [],
      petsList: [],
      cosmeticsList: [],
      childrenList: [],
      coastToCoastData: {},
      insightOverallData: {},
      successfulpicklData: {},
      activitiesWithIssuesSummaryData: {},
      incrementalTripsData: {},
      ProductPurchaseSummaryData: [],
      brandId: this.$route.params.brandId,
      mixedSeries: [{
        name: 'Growth',
        type: 'column',
        data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30]
      }, {
        name: 'Sales',
        type: 'area',
        data: [44, 55, 41, 67, 22, 43, 21, 41, 56, 27, 43]
      }],

      mixedchartOptions: {
        chart: {
          height: 350,
          type: 'line',
          stacked: false
        },
        stroke: {
          width: [0, 2, 5],
          curve: 'smooth'
        },
        plotOptions: {
          bar: {
            columnWidth: '50%'
          }
        },
        fill: {
          opacity: [0.85, 0.25, 1],
          gradient: {
            inverseColors: false,
            shade: 'light',
            type: 'vertical',
            opacityFrom: 0.85,
            opacityTo: 0.55,
            stops: [0, 100, 100, 100]
          }
        },
        labels: ['01/01/2003', '02/01/2003', '03/01/2003', '04/01/2003', '05/01/2003', '06/01/2003', '07/01/2003',
          '08/01/2003', '09/01/2003', '10/01/2003', '11/01/2003'
        ],
        markers: {
          size: 0
        },
        xaxis: {
          type: 'datetime'
        },
        yaxis: {
          title: {
            text: 'Tasks'
          },
          min: 0
        },
        tooltip: {
          shared: true,
          intersect: false,
          y: {
            formatter: function (y) {
              if (typeof y !== 'undefined') {
                return y.toFixed(0) + ' tasks'
              }
              return y
            }
          }
        }
      },

      pieS: [10, 90],
      swseries: [44, 55, 41, 17, 15],
      swchartOptions: {
        labels: ['California', 'Washington', 'Oregon', 'Florida', 'Texas']
      },
      PchartOptions: {
        chart: {
          width: 380,
          type: 'pie'
        },
        labels: ['Home', 'In-Store']
      },
      loadingStripeBalance: true,
      stripeBalance: 0,
      usersCountTasks: [],
      brandsCountTasks: [],
      genderDemographics: [],
      loadingPicklAverageTimes: true,
      averagePicklTimes: [],
      busy: true,
      allChartData: [],
      viewby: '1y',
      viewAverageTime: 'last-1y',
      getComparisionTime: 'last-1y',
      activeTab: 'pickl',
      chartData: [],
      ageDemographics: [],
      paymentChartData: [],
      dashboardContent: {},
      userRole: 'staff',
      userUrl: 'sadmin',
      columnD: [{
        name: 'Task Launched',
        data: [44, 55, 57, 56, 61, 58, 63, 60, 66]
      }, {
        name: 'Tasks Completed',
        data: [76, 85, 101, 98, 87, 105, 91, 114, 94]
      }, {
        name: 'Product Bought ',
        data: [5, 7, 4, 14, 3, 10, 5, 9, 6]
      }],

      columnF: [{
        name: 'Net Profit',
        data: [44, 55, 57, 56, 61, 58, 63, 60, 66]
      }, {
        name: 'Revenue',
        data: [76, 85, 101, 98, 87, 105, 91, 114, 94]
      }, {
        name: 'Free Cash Flow',
        data: [35, 41, 36, 26, 45, 48, 52, 53, 41]
      }],
      series: [{
        name: 'Insights',
        data: [250, 200, 240, 245, 200, 210, 280, 300, 150]
      }],
      chartOptions: {
        chart: {
          type: 'bar',
          height: 350
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded'
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        xaxis: {
          categories: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct']
        },
        yaxis: {
          title: {
            text: '$ (thousands)'
          }
        },
        fill: {
          opacity: 1
        }
      },
      barChartOptions: {
        chart: {
          type: 'bar',
          height: 350
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded'
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          show: true,
          width: 2,
          colors: ['transparent']
        },
        xaxis: {
          categories: ['Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb']
        },
        yaxis: {
          title: {
            text: 'Tasks'
          }
        },
        fill: {
          opacity: 1
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val + 'pickls'
            }
          }
        }
      }
    }
  },
  methods: {
    printDownload () {
      window.print()
    },
    togglePersonalFilters () {
      this.showPersonalDetailsFilter = !this.showPersonalDetailsFilter
    },
    toggleCampaignFilters () {
      this.showCampaignFilter = !this.showCampaignFilter
    },
    toggleRetailerFilters () {
      this.showRetailerFilter = !this.showRetailerFilter
    },
    toggleProductFilters () {
      this.showProductFilter = !this.showProductFilter
    },
    toggleGenderFilters () {
      this.showGenderFilter = !this.showGenderFilter
    },
    toggleEthnicFilters () {
      this.showEthnicFilter = !this.showEthnicFilter
    },
    togglePetsFilters () {
      this.showPetsFilter = !this.showPetsFilter
    },
    toggleCosmeticFilters () {
      this.showCosmeticFilter = !this.showCosmeticFilter
    },
    toggleChildrenFilters () {
      this.showChildrenFilter = !this.showChildrenFilter
    },

    getAllInsightQuestions () {
      this.$http
        .get(`brands/${this.brandId}/insight-question`)
        .then(
          function (response) {
            // console.log(response.body.data)
            if (response.body.data.length > 0) {
              this.selectedQuesetion = response.body.data[0]
              this.selectedQuestionId = response.body.data[0].id
              this.filters.questionId = response.body.data[0].id
              this.questionsList.push(...response.body.data)
            }
          })
    },
    getCampaignName () {
      this.$http
        .get(`brands/${this.brandId}/brand-campaign`)
        .then(
          function (response) {
            if (response.body.data.length > 0) {
              this.campaignList.push(...response.body.data)
            }
          })
    },
    getRetailerName () {
      this.$http
        .get(`brands/${this.brandId}/brand-retailer-name`)
        .then(
          function (response) {
            if (response.body.data.length > 0) {
              this.retailerList.push(...response.body.data)
            }
          })
    },
    getProductName () {
      this.$http
        .get(`brands/${this.brandId}/brand-products`)
        .then(
          function (response) {
            if (response.body.data.length > 0) {
              this.productList.push(...response.body.data)
            }
          })
    },
    getconsumerInsightsFilters () {
      this.$http
        .get(`brands/${this.brandId}/consumer-insights-filters`)
        .then(
          function (response) {
            this.ethnicBackground.push(...response.body.ethnicBackground)
            this.petsList.push(...response.body.petsList)
            this.cosmeticsList.push(...response.body.cosmeticsList)
            this.childrenList.push(...response.body.childrenList)
          })
    },

    setSelectedQuestion () {
      this.selectedQuesetion = this.questionsList.find(item => item.id === this.selectedQuestionId)
      this.filters.questionId = this.selectedQuestionId
      this.getSucessMetrics()
    },

    progress (event, progress, stepValue) {

    },
    progress_end (event) {
    },
    getSucessMetrics () {
      let payload = this.filters
      this.$http
        .get(`success-metrics/${this.brandId}`, { params: payload })
        .then(
          function (response) {
            this.coastToCoastData = response.body.CoastToCoastActivities
            this.activitiesWithIssuesSummaryData = response.body.activitiesWithIssuessummary
            this.incrementalTripsData = response.body.IncrementalTrips
            this.ProductPurchaseSummaryData = response.body.ProductPurchaseSummary
            this.successfulpicklData = response.body.successfulpickl
            this.picklPurchasesData = response.body.picklPurchases
            this.$set(this, 'insightData', response.body.insight)
            this.$set(this, 'insightOverallData', response.body.insightOverall)
            this.leadConversionRate = response.body.leadConversionRate
            this.leadConversionRateNumber = response.body.leadConversionRateNumber
            this.SalesConversionRate = response.body.SalesConversionRate
            this.SalesConversionRateNumber = response.body.SalesConversionRateNumber
            this.retentionRate = response.body.retentionRate
            this.retentionRateNumber = response.body.retentionRateNumber
            this.upsellRatio = response.body.upsellRatio
            this.upsellRatioNumber = response.body.upsellRatioNumber
            this.activitiesCompletedNumber = response.body.activitiesCompletedNumber
            this.activitiesCompletedPercentage = response.body.activitiesCompletedPercentage
            this.activitiesWithIssuesNumber = response.body.activitiesWithIssuesNumber
            this.activitiesWithIssuesPercentage = response.body.activitiesWithIssuesPercentage
            this.repeatLocations = response.body.repeatLocations
            this.byMeCreditConsumed = response.body.byMeCreditConsumed
            this.AverageLeadResponseTime = response.body.AverageLeadResponseTime
            this.FastestLeadResponseTime = response.body.FastestLeadResponseTime
            this.tripsFrequency = response.body.tripsFrequency
            this.basketSize = response.body.basketSize
            this.totalTimeMinutes = response.body.activityStats.total_time_minutes
            this.avgEngagementMinutes = response.body.activityStats.avg_engagement_minutes
            this.fastestActivityMinutes = response.body.activityStats.fastest_activity_minutes
            this.slowestActivityminutes = response.body.activityStats.slowest_activity_minutes
            this.productTotalTimeMinutes = response.body.activityProductIntractionStats.product_total_time_minutes
            this.productAvgEngagementMinutes = response.body.activityProductIntractionStats.product_avg_engagement_minutes
            this.productFastestActivityMinutes = response.body.activityProductIntractionStats.product_fastest_activity_minutes
            this.productSlowestActivityminutes = response.body.activityProductIntractionStats.product_slowest_activity_minutes
            this.touchPointTotalGeo = response.body.touchPointStatsGeo.total_touch_points
            this.touchPointAvgGeo = response.body.touchPointStatsGeo.avg_touch_points_per_activity
            this.photoAvgEngagementMinutes = response.body.activityPhotosTime.photo_avg_engagement_minutes
            this.photoFastestActivityMinutes = response.body.activityPhotosTime.photo_fastest_activity_minutes
            this.photoSlowestActivityMinutes = response.body.activityPhotosTime.photo_slowest_activity_minutes
            this.photoTotalTimeMinutes = response.body.activityPhotosTime.photo_total_time_minutes
            this.surveyAvgEngagementMinutes = response.body.activitySurveyTime.survey_avg_engagement_minutes
            this.surveyFastestActivityMinutes = response.body.activitySurveyTime.survey_fastest_activity_minutes
            this.surveySlowestActivityMinutes = response.body.activitySurveyTime.survey_slowest_activity_minutes
            this.surveyTotalTimeMinutes = response.body.activitySurveyTime.survey_total_time_minutes
            this.SelfieAvgEngagementMinutes = response.body.activitySelfieTime.selfie_avg_engagement_minutes
            this.SelfieFastestActivityMinutes = response.body.activitySelfieTime.selfie_fastest_activity_minutes
            this.SelfieSlowestActivityMinutes = response.body.activitySelfieTime.selfie_slowest_activity_minutes
            this.SelfieTotalTimeMinutes = response.body.activitySelfieTime.selfie_total_time_minutes
          }
        )
    }
  },
  created () {
    this.brandId = this.$route.params.brandId
    // this.onBoarded = this.$store.state.userData.onBoarded
  },
  mounted () {
    let userData = this.$store.state.userData
    this.userRole = userData.role
    if (this.userRole === 'super-admin') {
      this.userUrl = 'sadmin'
    } else {
      this.userUrl = 'staff'
    }
    this.getSucessMetrics()
    this.getAllInsightQuestions()
    this.getCampaignName()
    this.getRetailerName()
    this.getProductName()
    this.getconsumerInsightsFilters()
  },
  watch: {
    viewby () {
      this.getSadminReports()
    },
    viewAverageTime () {
      this.getPicklAverageTimes()
    },
    selectedQuestionId (newVal, oldVal) {
      this.setSelectedQuestion()
    }
  }
}

</script>

<style scoped>
.padd-graph {
  padding: 25px;
}
.tab-content {
  overflow: hidden;
}
.graph-label,
.apexcharts-xaxis tspan {
  color: rgba(0, 0, 0, 0.7);
  font-family: "Google Sans", "Product Sans", sans-serif !important;
}
.graph-label {
  font-size: 15px;
}
.apexcharts-tooltip {
  overflow: visible;
}
.filter-box select:hover{
  background: transparent;
}
.filter-box select{
  height: 45px;
  border: 1px solid #000;
}
.graph-tooltip {
  position: relative;
  background: #782b54;
  color: #fff;
  font-weight: 500;
  font-size: 14px;
  padding: 3px 10px;
  border-radius: 5px;
}
.tab-content,
.green-border-box {
  overflow: unset;
}
.filter.open .filter-box{
  display: block !important;
  height: 100vh;
  width: 340px;
  right: 0;
  position: fixed;
  top: 0;
  border: 0px;
  padding: 20px;
  overflow-y: overlay;
  overflow-x: hidden;
}
.apply-btn{
  display: block !important;
  text-align: center;
  max-width: 135px;
  margin: 30px auto;
  padding: 10px 35px !important;
  font-size: 17px !important;
  margin-left: 0px !important;
  float: left;
}
.filter{
  position: relative;
}
.filter a{
    background: #641c44;
    color: #fff;
    padding: 8px 20px;
    font-size: 16px;
    letter-spacing: 0.6px;
    margin-left: 15px;
    display: inline;
}
.filter-box input{
    height: 45px;
    font-size: 15px;
    margin-bottom: 10px;
}
.filter-box label{
    color: #000;
    font-size: 16px;
    margin-top: 15px;
}
.coast-box h3{
    font-size: 21px;
}
.coast-box {
    border: 1px solid #12db6d;
    padding: 10px 20px;
}
.filter a:hover{
  text-decoration: none;
}
.media_insights {
    clear: both;
    text-align: center;
    margin-top: 100px;
    float: left;
    width: 100%;
}
@media only screen and (max-width: 991px) and (min-width: 576px) {
.apexcharts-xaxis-label:nth-last-child(even) {
    display: none;
  }
}

@media only screen and (max-width: 767px) and (min-width: 576px) {
  .sort-control {
    margin-top: 15px;
  }

.filter3m .apexcharts-xaxis-label,
.filter1m .apexcharts-xaxis-label {
    display: none;
  }

.filter3m .apexcharts-xaxis-label:first-child,
.filter3m .apexcharts-xaxis-label:nth-last-child(2),
.filter1m .apexcharts-xaxis-label:first-child,
.filter1m .apexcharts-xaxis-label:nth-last-child(2),
.filter3m .apexcharts-xaxis-label:nth-last-child(5),
.filter1m .apexcharts-xaxis-label:nth-last-child(4) {
    display: block;
  }
}

@media only screen and (max-width: 575px) {
  .sort-control {
    margin-top: 15px;
  }

.apexcharts-xaxis tspan {
    font-size: 12px;
}
.padd-graph {
    padding: 15px;
}

.filter6m .apexcharts-xaxis-label:nth-last-child(2n) {
    display: none;
}
.filter1y .apexcharts-xaxis-label:nth-last-child(4n-1),
.filter1y .apexcharts-xaxis-label:nth-last-child(4n),
.filter1y .apexcharts-xaxis-label:nth-last-child(4n-2) {
    display: none;
  }
.filter3m .apexcharts-xaxis-label,
.filter1m .apexcharts-xaxis-label {
    display: none;
  }
.filter3m .apexcharts-xaxis-label:first-child,
.filter3m .apexcharts-xaxis-label:nth-last-child(2),
.filter1m .apexcharts-xaxis-label:first-child,
.filter1m .apexcharts-xaxis-label:nth-last-child(2) {
    display: block;
  }
}

.top-tab {
  text-align: center;
}
.top-tab ul{
    display: inline-flex;
}
.top-tab ul li{
    padding: 6px 15px;
    list-style: none;
    margin-bottom: -15px;
}
.top-tab .nav-tabs li a{
  border-bottom: 2px solid #fff;
}
.top-tab .nav-tabs>li.active>a{
    border-bottom: 7px solid #12db6d;
}
.top-tab .nav-tabs{
    border-bottom: 0px !important;
}
.top-tab {
    box-shadow: 1px 3px 5px rgba(0, 0, 0, 0.3);
    margin-bottom: 30px;
}

.circular-progress {
  width: var(--progress-bar-width);
  height: var(--progress-bar-height);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.inner-circle {
  position: absolute;
  width: calc(var(--progress-bar-width) - 30px);
  height: calc(var(--progress-bar-height) - 30px);
  border-radius: 50%;
  background-color: lightgrey;
}

.percentage {
  position: relative;
  font-size: var(--font-size);
  color: rgb(0, 0, 0, 0.8);
}
.filter-box ul{
  list-style: none;
  padding-left: 0px;
  padding-top: 10px;
}
.filter-box button{
    display: block;
    border: 0px;
    background: transparent;
    padding: 0px;
    color: #000;
    font-size: 17px;
    margin-top: 20px;
}
@media screen and (max-width: 800px) {
  :root {
    --progress-bar-width: 150px;
    --progress-bar-height: 150px;
    --font-size: 1.3rem;
  }
}

@media screen and (max-width: 500px) {
  :root {
    --progress-bar-width: 120px;
    --progress-bar-height: 120px;
    --font-size: 1rem;
  }
}
@media print {
  .sidebar-desktop,
  .filter.pull-right,
  .top-tab{
    display: none;
  }
}
#CampaignInsights h3 {
    font-size: 22px;
    margin-bottom: 3px;
}
</style>
